import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: "RelatedContract",
  props: {
    type: {
      type: String,
      default: "CMB"
    }
  },
  data: function data() {
    return {
      visible: false,
      searchForm: {
        current: 1,
        size: 10,
        partyA: "",
        contractNumber: ""
      },
      tableData: [],
      loading: false,
      saveLoading: false,
      radioIndex: null,
      selectedRow: {},
      parentForm: {}
    };
  },
  methods: {
    pageChange: function pageChange(current) {
      this.searchForm.current = current;
      this.getData();
    },
    show: function show(form) {
      this.parentForm = form;
      this.visible = true;
      this.getData();
    },
    getData: function getData(type) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this.loading = true;
              if (type === "search") {
                _this.searchForm.current = 1;
                _this.total = 0;
              }
              _context.p = 1;
              _this.searchForm.status = 'INCOMPLETE';
              _context.n = 2;
              return _this.$api.getSigningAwaitList(_this.searchForm);
            case 2:
              res = _context.v;
              _this.tableData = res.data.content || [];
              _this.total = res.data.totalSize || 0;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error("获取签约列表失败", _t);
            case 4:
              _context.p = 4;
              _this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }))();
    },
    onRadioChange: function onRadioChange(row) {
      this.selectedRow = row;
    },
    save: function save() {
      var _this2 = this;
      if (!this.radioIndex) {
        this.$message.warning("请选择合同");
        return;
      }
      this.saveLoading = true;
      var params = {
        "contractCode": this.selectedRow.contractNumber,
        "transactionNo": this.parentForm.receiptWaterNbr
      };
      this.$api.trialCalculation(params).then(function (res) {
        _this2.$emit("save", _objectSpread(_objectSpread({}, params), res.data));
        _this2.close();
      }).finally(function () {
        _this2.saveLoading = false;
      });
    },
    close: function close() {
      this.visible = false;
      this.radioIndex = null;
      this.selectedRow = {};
      this.searchForm = {
        current: 1,
        size: 10,
        partyA: "",
        contractNumber: ""
      };
    }
  }
};